var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 43,
    viewBox: "0 0 55 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M49.532 0.898003C48.0793 -0.441002 45.658 -0.22958 44.4128 1.1799L40.6772 5.47881L23.3827 25.7753C23.1752 26.0572 23.0368 26.3391 23.0368 26.6915L22.2067 34.2322C22.1375 34.7255 22.3451 35.2893 22.7601 35.6417C23.0368 35.9236 23.4519 36.0645 23.7978 36.0645C23.9362 36.0645 24.0745 36.0645 24.1437 35.994L31.4074 34.2322C31.7533 34.1617 32.03 33.9503 32.2375 33.7389L50.5697 12.2443L53.1984 9.21393C54.5128 7.6635 54.3744 5.33786 52.8525 3.99886L49.532 0.898003ZM46.7649 3.36459C46.9724 3.0827 47.1799 3.15317 47.3875 3.29412L50.7772 6.39497C50.9847 6.53592 50.9847 6.81782 50.8464 7.02924L49.2553 8.86156L45.1738 5.19692L46.7649 3.36459ZM25.8731 30.1447L27.7409 31.8361L25.6656 32.3294L25.8731 30.1447ZM30.9231 30.3561L26.8416 26.6915L43.0293 7.6635L47.1108 11.3282L30.9231 30.3561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.8401 26.9366C41.9286 26.9366 41.2275 27.629 41.2275 28.529V39.8836H3.22528V5.95827H34.1459C35.0574 5.95827 35.7585 5.26591 35.7585 4.36585C35.7585 3.46579 35.0574 2.77344 34.1459 2.77344H2.87471C1.26207 2.77344 0 4.08891 0 5.61209V40.1606C0 41.753 1.33218 42.9992 2.87471 42.9992H41.5079C43.1206 42.9992 44.3827 41.6838 44.3827 40.1606V28.529C44.4528 27.6982 43.6815 26.9366 42.8401 26.9366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.1435 18.032H13.6629C14.5645 18.032 15.258 17.4289 15.258 16.6449C15.258 15.8609 14.5645 15.2578 13.6629 15.2578H7.1435C6.24189 15.2578 5.54834 15.8609 5.54834 16.6449C5.54834 17.3686 6.24189 18.032 7.1435 18.032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.9677 9.70936C24.9677 8.92535 24.2692 8.32227 23.3611 8.32227H7.15498C6.24688 8.32227 5.54834 8.92535 5.54834 9.70936C5.54834 10.4934 6.24688 11.0965 7.15498 11.0965H23.3611C24.2692 11.0965 24.9677 10.4934 24.9677 9.70936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.8065 22.1937C20.8065 21.4097 20.1643 20.8066 19.3295 20.8066H8.41255C7.57772 20.8066 6.93555 21.4097 6.93555 22.1937C6.93555 22.9777 7.57772 23.5808 8.41255 23.5808H19.3295C20.1643 23.5808 20.8065 22.9777 20.8065 22.1937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.51491 30.5154H12.2917C13.1843 30.5154 13.871 29.9123 13.871 29.1283C13.871 28.3443 13.1843 27.7412 12.2917 27.7412H8.51491C7.62223 27.7412 6.93555 28.3443 6.93555 29.1283C6.93555 29.9123 7.62223 30.5154 8.51491 30.5154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.44448 36.0642H15.1363C15.9892 36.0642 16.6452 35.4611 16.6452 34.6771C16.6452 33.8931 15.9892 33.29 15.1363 33.29H8.44448C7.59161 33.29 6.93555 33.8931 6.93555 34.6771C6.93555 35.4611 7.59161 36.0642 8.44448 36.0642Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar1);
export default __webpack_public_path__ + "static/media/bar1.944dc524be50b74696f74937dbc8ab97.svg";
export { ForwardRef as ReactComponent };